(function(win,doc){

  const myFunc = function(){
    let lastPosition = -1;
    let nk_sp_tt = document.querySelector('#nk_sp_tt');
    let nk_sp_td = document.querySelector('#nk_sp_td');
    
    const nk_sp_title = document.querySelector('#nk-sidebar-sp-ttl');
    const titles = document.querySelectorAll('.nk-titles');
    for (let i = 0; i < titles.length; i++) {
      let hash = 'nk-titles-'+i;
      titles[i].id = hash;
      let el_p = document.createElement('div');
      let el = document.createElement('a');
      (function(el){
        el.addEventListener('click',function () {
          document.body.classList.remove('nk-open');
        });    
      })(el);
      el.textContent = titles[i].getAttribute('data-name');
      el.href = '#'+hash;
      el_p.append(el);
      document.querySelector('#nk-sidebar').append(el_p);
    }
    const nk_sidebar = document.querySelector('#nk-sidebar');
    const navLinks = document.querySelectorAll('#nk-sidebar>div');
    
    nk_sp_title.addEventListener('click',function () {
      document.body.classList.add('nk-open');
    });    
    nk_sp_tt.addEventListener('click',function () {
      document.body.classList.remove('nk-open');
    });    
    nk_sp_td.addEventListener('click',function () {
      document.body.classList.remove('nk-open');
    });    

    function updateActiveLink() {
      let viewportHeight = window.innerHeight;
      let middleScreen = window.scrollY + viewportHeight * 0.5;
      
      middleScreen = window.scrollY;

      let is = false;
      for (let i = 0; i < titles.length; i++) {
        const currentTitle = titles[i];
        const nextTitle = titles[i + 1];
        /*
        const titleHeight = currentTitle.offsetHeight;
        const top = currentTitle.offsetTop + titleHeight;
        */
        const top = currentTitle.offsetTop;
        const bottom = nextTitle ? nextTitle.offsetTop : document.body.offsetHeight;
        if (middleScreen >= top && middleScreen < bottom ) {
          navLinks.forEach(link => link.classList.remove('nk-active'));
          navLinks[i].classList.add('nk-active');
          nk_sp_title.querySelector('span').textContent = titles[i].getAttribute('data-name');
          is = true;
          break;
        }
      }

      if(!is){
          let i = 0;
          navLinks.forEach(link => link.classList.remove('nk-active'));
          navLinks[i].classList.add('nk-active');
          nk_sp_title.querySelector('span').textContent = titles[i].getAttribute('data-name');
      }
    }

    function handleScroll() {
      const currentPosition = window.scrollY;
      if (lastPosition !== currentPosition) {
        lastPosition = currentPosition;
        updateActiveLink(); // アクティブ状態の更新
      }
    }

    function loop() {
      handleScroll();
      requestAnimationFrame(loop);
    }

      requestAnimationFrame(function(){
        updateActiveLink();
        requestAnimationFrame(loop);
      });
  };

  if(window.myDOMContentLoadedIs){
    myFunc();
  }else{
    document.addEventListener('myDOMContentLoaded',() => {
        myFunc();
    });    
  }

})(window,document);